<div class="position-relative btn-container">
  <button
  mat-raised-button
  (click)="picker.open()"
  [class.isFocused]="!isFocused"
>
  <img src="./assets/media/icons/duotune/files/fil002.svg" />
  {{ selectDatesText }}
</button>
  <mat-form-field appearance="fill">
    <mat-date-range-input [formGroup]="rangeInterval" [rangePicker]="picker">
      <input matStartDate formControlName="start" placeholder="Start date" />
      <input matEndDate formControlName="end" placeholder="End date" />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
    <mat-error
      *ngIf="rangeInterval.controls.start.hasError('matStartDateInvalid')"
      >Invalid start date</mat-error
    >
    <mat-error *ngIf="rangeInterval.controls.end.hasError('matEndDateInvalid')"
      >Invalid end date</mat-error
    >
  </mat-form-field>
</div>
